export default "__VITE_ASSET__GrARzLcj__"